import { z } from "zod";
import { ACTION_PRIORITIES, ACTION_STATUSES } from "@/shared/pulse/actions/action-vocabulary";

/// URL-state for the workspace Actions list filters (S3), plus the rates
/// strip's analytics window. Falls back to 30d for a missing/unrecognised
/// value, same catch idiom as `comparison.route.search`'s `metric`.
export const workspaceActionsSearchSchema = z
  .object({
    status: z.enum(ACTION_STATUSES).optional(),
    priority: z.enum(ACTION_PRIORITIES).optional(),
    range: z.enum(["30d", "90d", "all"]).catch("30d"),
  })
  .strict();

export type WorkspaceActionsSearch = z.infer<typeof workspaceActionsSearchSchema>;
